import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const airlock = defineConnector({
  identifier: "airlock",
  name: "Airlock",
  tagLine: "Secure access for applications and APIs",
  logo,
  protocol: "http",
  tags: ["security", "identity"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/airlock/rest/.*`
      : "https://[^/]*/airlock/rest/.*",
  auth: customAuth("airlock"),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the [Airlock Gateway REST API docs](https://docs.airlock.com/gateway/latest/rest-api/config-rest-api.html#autentication-overview) to obtain an API key for your deployment.",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://gateway.example.com",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText: "The base URL of your Airlock Gateway.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) => ({
      url: `${apiAddress}/airlock/rest/session/create`,
      method: "POST",
    }),
  },
});
